// Pre-generated narration clips (ElevenLabs "Candy – Young and Sweet") for the
// read-aloud hints, served over jsDelivr from the public cquidet-pro/learn-draw-audio
// repo (zero Firebase egress). The player plays the matching clip for a step's
// spoken hint and falls back to the browser voice for anything without a clip.
//
// THIS FILE IS GENERATED from the clips present in the audio repo — do not edit by
// hand; add clips to the repo and regenerate (gen-manifest.mjs).
//
// Language: en. Layout: common/<slug>.mp3 (lines shared by many
// drawings) and <drawing-id>/<slug>.mp3 (a drawing's own hints). A
// drawing-specific clip wins over the shared/common one.
import { clipSlug } from "./clipSlug";

const AUDIO_BASE = "https://cdn.jsdelivr.net/gh/cquidet-pro/learn-draw-audio@1901598ca370316d6340d2794d8f6e09f9843367";

// Lines shared by many drawings: slug → path within the audio repo.
const COMMON: Record<string, string> = {
  "add-3-stripes-across": "common/add-3-stripes-across.mp3",
  "add-3-stripes-up-and-down": "common/add-3-stripes-up-and-down.mp3",
  "add-9-stripes-across": "common/add-9-stripes-across.mp3",
  "add-a-big-cloud-of-leaves": "common/add-a-big-cloud-of-leaves.mp3",
  "add-a-brave-smile": "common/add-a-brave-smile.mp3",
  "add-a-cross-a-tall-line-and-a-wide-line": "common/add-a-cross-a-tall-line-and-a-wide-line.mp3",
  "add-a-door-handle-and-headlight": "common/add-a-door-handle-and-headlight.mp3",
  "add-a-flowing-cape": "common/add-a-flowing-cape.mp3",
  "add-a-line-across-the-middle": "common/add-a-line-across-the-middle.mp3",
  "add-a-little-arm": "common/add-a-little-arm.mp3",
  "add-a-little-nose": "common/add-a-little-nose.mp3",
  "add-a-long-horse-head-from-the-side": "common/add-a-long-horse-head-from-the-side.mp3",
  "add-a-long-neck-and-a-big-head": "common/add-a-long-neck-and-a-big-head.mp3",
  "add-a-long-swishy-tail": "common/add-a-long-swishy-tail.mp3",
  "add-a-magic-wand": "common/add-a-magic-wand.mp3",
  "add-a-nose-and-a-smile": "common/add-a-nose-and-a-smile.mp3",
  "add-a-nose-seen-from-the-side": "common/add-a-nose-seen-from-the-side.mp3",
  "add-a-pointy-ear": "common/add-a-pointy-ear.mp3",
  "add-a-rosy-cheek-and-a-smile": "common/add-a-rosy-cheek-and-a-smile.mp3",
  "add-a-second-row-of-spikes": "common/add-a-second-row-of-spikes.mp3",
  "add-a-shiny-highlight": "common/add-a-shiny-highlight.mp3",
  "add-a-smile": "common/add-a-smile.mp3",
  "add-a-smile-and-rosy-cheeks": "common/add-a-smile-and-rosy-cheeks.mp3",
  "add-a-smile-and-whiskers": "common/add-a-smile-and-whiskers.mp3",
  "add-a-sparkly-jewelled-crown": "common/add-a-sparkly-jewelled-crown.mp3",
  "add-a-star": "common/add-a-star.mp3",
  "add-a-swishy-tail": "common/add-a-swishy-tail.mp3",
  "add-a-zig-zag-lightning-bolt": "common/add-a-zig-zag-lightning-bolt.mp3",
  "add-an-eye-a-nostril-and-a-smile": "common/add-an-eye-a-nostril-and-a-smile.mp3",
  "add-an-eye-and-a-happy-smile": "common/add-an-eye-and-a-happy-smile.mp3",
  "add-an-eye-and-spots": "common/add-an-eye-and-spots.mp3",
  "add-another-row-of-rain": "common/add-another-row-of-rain.mp3",
  "add-arms-and-legs": "common/add-arms-and-legs.mp3",
  "add-bark-lines-on-the-trunk": "common/add-bark-lines-on-the-trunk.mp3",
  "add-big-sharp-teeth": "common/add-big-sharp-teeth.mp3",
  "add-big-spots-on-the-wings": "common/add-big-spots-on-the-wings.mp3",
  "add-bumpy-plates-along-its-back": "common/add-bumpy-plates-along-its-back.mp3",
  "add-cool-swooshy-hair": "common/add-cool-swooshy-hair.mp3",
  "add-curly-smoke-from-the-chimney": "common/add-curly-smoke-from-the-chimney.mp3",
  "add-diagonal-rays-in-the-corners": "common/add-diagonal-rays-in-the-corners.mp3",
  "add-eight-petals-all-around": "common/add-eight-petals-all-around.mp3",
  "add-eyes-and-a-big-smile": "common/add-eyes-and-a-big-smile.mp3",
  "add-fins-on-top-and-bottom": "common/add-fins-on-top-and-bottom.mp3",
  "add-four-legs-that-join-the-body": "common/add-four-legs-that-join-the-body.mp3",
  "add-four-little-feet": "common/add-four-little-feet.mp3",
  "add-front-legs-and-paws": "common/add-front-legs-and-paws.mp3",
  "add-lilac-swirls-too": "common/add-lilac-swirls-too.mp3",
  "add-little-golden-dots": "common/add-little-golden-dots.mp3",
  "add-rosy-cheeks-and-a-smile": "common/add-rosy-cheeks-and-a-smile.mp3",
  "add-shiny-hubcaps-in-the-wheels": "common/add-shiny-hubcaps-in-the-wheels.mp3",
  "add-some-yummy-apples": "common/add-some-yummy-apples.mp3",
  "add-straight-sunny-rays": "common/add-straight-sunny-rays.mp3",
  "add-the-back-legs": "common/add-the-back-legs.mp3",
  "add-the-big-round-shell": "common/add-the-big-round-shell.mp3",
  "add-the-big-top-wings": "common/add-the-big-top-wings.mp3",
  "add-the-body-and-collar": "common/add-the-body-and-collar.mp3",
  "add-the-body-and-outfit": "common/add-the-body-and-outfit.mp3",
  "add-the-bottom-wings": "common/add-the-bottom-wings.mp3",
  "add-the-eye-mask": "common/add-the-eye-mask.mp3",
  "add-the-eye-nose-and-a-smile": "common/add-the-eye-nose-and-a-smile.mp3",
  "add-the-eyes": "common/add-the-eyes.mp3",
  "add-the-first-row-of-raindrops": "common/add-the-first-row-of-raindrops.mp3",
  "add-the-first-row-of-spikes": "common/add-the-first-row-of-spikes.mp3",
  "add-the-front-legs-and-paws": "common/add-the-front-legs-and-paws.mp3",
  "add-the-front-legs-one-prancing": "common/add-the-front-legs-one-prancing.mp3",
  "add-the-gill-line-and-an-eye": "common/add-the-gill-line-and-an-eye.mp3",
  "add-the-pointy-cone-underneath": "common/add-the-pointy-cone-underneath.mp3",
  "add-the-rainbow-fringe-on-top": "common/add-the-rainbow-fringe-on-top.mp3",
  "add-the-roof-and-a-chimney": "common/add-the-roof-and-a-chimney.mp3",
  "add-the-round-middle": "common/add-the-round-middle.mp3",
  "add-the-sitting-body": "common/add-the-sitting-body.mp3",
  "add-the-stars": "common/add-the-stars.mp3",
  "add-the-windows": "common/add-the-windows.mp3",
  "add-two-big-eyes": "common/add-two-big-eyes.mp3",
  "add-two-big-wheels": "common/add-two-big-wheels.mp3",
  "add-two-eyes": "common/add-two-eyes.mp3",
  "add-two-floppy-ears": "common/add-two-floppy-ears.mp3",
  "add-two-little-ears": "common/add-two-little-ears.mp3",
  "add-two-little-feelers": "common/add-two-little-feelers.mp3",
  "add-two-little-hooves": "common/add-two-little-hooves.mp3",
  "add-two-pointy-ears": "common/add-two-pointy-ears.mp3",
  "add-two-round-eyes": "common/add-two-round-eyes.mp3",
  "add-windows-with-little-panes": "common/add-windows-with-little-panes.mp3",
  "all-done-let-s-watch-it-again": "common/all-done-let-s-watch-it-again.mp3",
  "and-that-s-little-you": "common/and-that-s-little-you.mp3",
  "buttery-yellow-for-the-horn": "common/buttery-yellow-for-the-horn.mp3",
  "draw-4-thin-red-diagonal-stripes": "common/draw-4-thin-red-diagonal-stripes.mp3",
  "draw-8-blue-triangles-in-the-corners": "common/draw-8-blue-triangles-in-the-corners.mp3",
  "draw-a-big-circle-in-the-middle": "common/draw-a-big-circle-in-the-middle.mp3",
  "draw-a-big-fluffy-cloud": "common/draw-a-big-fluffy-cloud.mp3",
  "draw-a-big-round-body": "common/draw-a-big-round-body.mp3",
  "draw-a-big-round-head": "common/draw-a-big-round-head.mp3",
  "draw-a-big-round-sun": "common/draw-a-big-round-sun.mp3",
  "draw-a-big-thick-red-cross": "common/draw-a-big-thick-red-cross.mp3",
  "draw-a-big-twinkly-star": "common/draw-a-big-twinkly-star.mp3",
  "draw-a-crescent-moon": "common/draw-a-crescent-moon.mp3",
  "draw-a-round-head": "common/draw-a-round-head.mp3",
  "draw-creamy-swirls-in-the-mane-and-tail": "common/draw-creamy-swirls-in-the-mane-and-tail.mp3",
  "draw-daddy": "common/draw-daddy.mp3",
  "draw-her-big-flowy-dress": "common/draw-her-big-flowy-dress.mp3",
  "draw-her-hair-fringe": "common/draw-her-hair-fringe.mp3",
  "draw-mommy": "common/draw-mommy.mp3",
  "draw-the-back-and-the-round-tummy": "common/draw-the-back-and-the-round-tummy.mp3",
  "draw-the-big-happy-eyes": "common/draw-the-big-happy-eyes.mp3",
  "draw-the-big-sparkly-eyes": "common/draw-the-big-sparkly-eyes.mp3",
  "draw-the-body-segments-and-antennae": "common/draw-the-body-segments-and-antennae.mp3",
  "draw-the-car-body": "common/draw-the-car-body.mp3",
  "draw-the-door-with-a-doorknob": "common/draw-the-door-with-a-doorknob.mp3",
  "draw-the-face-and-cool-hair": "common/draw-the-face-and-cool-hair.mp3",
  "draw-the-fish-body": "common/draw-the-fish-body.mp3",
  "draw-the-flag-s-box": "common/draw-the-flag-s-box.mp3",
  "draw-the-flowing-mane": "common/draw-the-flowing-mane.mp3",
  "draw-the-grassy-ground": "common/draw-the-grassy-ground.mp3",
  "draw-the-happy-eyes": "common/draw-the-happy-eyes.mp3",
  "draw-the-head-with-a-soft-snout": "common/draw-the-head-with-a-soft-snout.mp3",
  "draw-the-hero-s-head": "common/draw-the-hero-s-head.mp3",
  "draw-the-left-side-of-the-heart": "common/draw-the-left-side-of-the-heart.mp3",
  "draw-the-magic-horn": "common/draw-the-magic-horn.mp3",
  "draw-the-round-body-and-pointy-nose": "common/draw-the-round-body-and-pointy-nose.mp3",
  "draw-the-round-ice-cream-scoop": "common/draw-the-round-ice-cream-scoop.mp3",
  "draw-the-snail-s-long-foot": "common/draw-the-snail-s-long-foot.mp3",
  "draw-the-stem-and-two-leaves": "common/draw-the-stem-and-two-leaves.mp3",
  "draw-the-swirl-on-the-shell": "common/draw-the-swirl-on-the-shell.mp3",
  "draw-the-trunk-with-roots": "common/draw-the-trunk-with-roots.mp3",
  "draw-the-unicorn-s-round-body": "common/draw-the-unicorn-s-round-body.mp3",
  "draw-the-waffle-lines-on-the-cone": "common/draw-the-waffle-lines-on-the-cone.mp3",
  "draw-the-walls-a-big-square": "common/draw-the-walls-a-big-square.mp3",
  "draw-your-big-brother-or-sister": "common/draw-your-big-brother-or-sister.mp3",
  "finish-the-arcs-with-violet": "common/finish-the-arcs-with-violet.mp3",
  "finish-with-a-happy-smile": "common/finish-with-a-happy-smile.mp3",
  "finish-with-a-lightning-emblem-in-a-shield": "common/finish-with-a-lightning-emblem-in-a-shield.mp3",
  "finish-with-grass-at-the-bottom": "common/finish-with-grass-at-the-bottom.mp3",
  "finish-with-the-ground-and-a-fern": "common/finish-with-the-ground-and-a-fern.mp3",
  "flow-the-wavy-mane-down-the-neck": "common/flow-the-wavy-mane-down-the-neck.mp3",
  "give-her-a-happy-smile": "common/give-her-a-happy-smile.mp3",
  "give-it-a-flowing-tail": "common/give-it-a-flowing-tail.mp3",
  "give-it-a-happy-face": "common/give-it-a-happy-face.mp3",
  "give-it-four-chunky-legs-and-feet": "common/give-it-four-chunky-legs-and-feet.mp3",
  "give-the-sun-a-happy-face": "common/give-the-sun-a-happy-face.mp3",
  "green-next": "common/green-next.mp3",
  "indigo-after-that": "common/indigo-after-that.mp3",
  "last-of-all-write-the-name-c-i-r-c-l-e": "common/last-of-all-write-the-name-c-i-r-c-l-e.mp3",
  "last-of-all-write-the-name-c-r-e-s-c-e-n-t": "common/last-of-all-write-the-name-c-r-e-s-c-e-n-t.mp3",
  "last-of-all-write-the-name-d-i-a-m-o-n-d": "common/last-of-all-write-the-name-d-i-a-m-o-n-d.mp3",
  "last-of-all-write-the-name-d-i-n-o-s-a-u-r": "common/last-of-all-write-the-name-d-i-n-o-s-a-u-r.mp3",
  "last-of-all-write-the-name-h-e-a-r-t": "common/last-of-all-write-the-name-h-e-a-r-t.mp3",
  "last-of-all-write-the-name-h-e-x-a-g-o-n": "common/last-of-all-write-the-name-h-e-x-a-g-o-n.mp3",
  "last-of-all-write-the-name-i-c-e-c-r-e-a-m": "common/last-of-all-write-the-name-i-c-e-c-r-e-a-m.mp3",
  "last-of-all-write-the-name-o-c-t-a-g-o-n": "common/last-of-all-write-the-name-o-c-t-a-g-o-n.mp3",
  "last-of-all-write-the-name-o-v-a-l": "common/last-of-all-write-the-name-o-v-a-l.mp3",
  "last-of-all-write-the-name-p-a-r-a-l-l-e-l-o-g-r-a-m": "common/last-of-all-write-the-name-p-a-r-a-l-l-e-l-o-g-r-a-m.mp3",
  "last-of-all-write-the-name-p-e-n-t-a-g-o-n": "common/last-of-all-write-the-name-p-e-n-t-a-g-o-n.mp3",
  "last-of-all-write-the-name-r-e-c-t-a-n-g-l-e": "common/last-of-all-write-the-name-r-e-c-t-a-n-g-l-e.mp3",
  "last-of-all-write-the-name-s-n-a-i-l": "common/last-of-all-write-the-name-s-n-a-i-l.mp3",
  "last-of-all-write-the-name-s-q-u-a-r-e": "common/last-of-all-write-the-name-s-q-u-a-r-e.mp3",
  "last-of-all-write-the-name-s-t-a-r": "common/last-of-all-write-the-name-s-t-a-r.mp3",
  "last-of-all-write-the-name-t-r-a-p-e-z-i-u-m": "common/last-of-all-write-the-name-t-r-a-p-e-z-i-u-m.mp3",
  "last-of-all-write-the-name-t-r-i-a-n-g-l-e": "common/last-of-all-write-the-name-t-r-i-a-n-g-l-e.mp3",
  "last-of-all-write-the-name-u-n-i-c-o-r-n": "common/last-of-all-write-the-name-u-n-i-c-o-r-n.mp3",
  "lilac-swirls-next": "common/lilac-swirls-next.mp3",
  "make-a-little-flag-box-in-the-corner": "common/make-a-little-flag-box-in-the-corner.mp3",
  "now-bring-it-to-life-with-color": "common/now-bring-it-to-life-with-color.mp3",
  "now-color-her-all-in": "common/now-color-her-all-in.mp3",
  "now-color-it-all-in": "common/now-color-it-all-in.mp3",
  "now-color-it-in": "common/now-color-it-in.mp3",
  "now-color-the-cloud-in": "common/now-color-the-cloud-in.mp3",
  "now-color-the-whole-rainbow-in": "common/now-color-the-whole-rainbow-in.mp3",
  "now-colour-the-flag-in": "common/now-colour-the-flag-in.mp3",
  "now-colour-the-shirt-blue": "common/now-colour-the-shirt-blue.mp3",
  "now-colour-your-circle-in": "common/now-colour-your-circle-in.mp3",
  "now-colour-your-crescent-in": "common/now-colour-your-crescent-in.mp3",
  "now-colour-your-diamond-in": "common/now-colour-your-diamond-in.mp3",
  "now-colour-your-family-in": "common/now-colour-your-family-in.mp3",
  "now-colour-your-heart-in": "common/now-colour-your-heart-in.mp3",
  "now-colour-your-hexagon-in": "common/now-colour-your-hexagon-in.mp3",
  "now-colour-your-ice-cream-in": "common/now-colour-your-ice-cream-in.mp3",
  "now-colour-your-octagon-in": "common/now-colour-your-octagon-in.mp3",
  "now-colour-your-oval-in": "common/now-colour-your-oval-in.mp3",
  "now-colour-your-parallelogram-in": "common/now-colour-your-parallelogram-in.mp3",
  "now-colour-your-pentagon-in": "common/now-colour-your-pentagon-in.mp3",
  "now-colour-your-rectangle-in": "common/now-colour-your-rectangle-in.mp3",
  "now-colour-your-snail-in": "common/now-colour-your-snail-in.mp3",
  "now-colour-your-square-in": "common/now-colour-your-square-in.mp3",
  "now-colour-your-star-in": "common/now-colour-your-star-in.mp3",
  "now-colour-your-trapezium-in": "common/now-colour-your-trapezium-in.mp3",
  "now-colour-your-triangle-in": "common/now-colour-your-triangle-in.mp3",
  "now-colour-your-unicorn-in": "common/now-colour-your-unicorn-in.mp3",
  "now-creamy-peach-swirls": "common/now-creamy-peach-swirls.mp3",
  "now-mirror-it-on-the-right": "common/now-mirror-it-on-the-right.mp3",
  "now-orange": "common/now-orange.mp3",
  "now-the-next-colour": "common/now-the-next-colour.mp3",
  "pink-for-the-mane": "common/pink-for-the-mane.mp3",
  "read-aloud-on": "common/read-aloud-on.mp3",
  "spread-a-magical-wing": "common/spread-a-magical-wing.mp3",
  "spread-two-magical-wings": "common/spread-two-magical-wings.mp3",
  "sprinkle-some-sparkles": "common/sprinkle-some-sparkles.mp3",
  "start-with-a-big-round-head": "common/start-with-a-big-round-head.mp3",
  "start-with-a-red-arc": "common/start-with-a-red-arc.mp3",
  "start-with-the-round-head": "common/start-with-the-round-head.mp3",
  "sweep-the-fringe-around-the-horn": "common/sweep-the-fringe-around-the-horn.mp3",
  "swish-a-big-wavy-tail": "common/swish-a-big-wavy-tail.mp3",
  "then-blue": "common/then-blue.mp3",
  "then-yellow": "common/then-yellow.mp3",
  "this-is-a-circle-draw-one-big-round-circle": "common/this-is-a-circle-draw-one-big-round-circle.mp3",
  "this-is-a-crescent-the-curvy-shape-of-the-moon": "common/this-is-a-crescent-the-curvy-shape-of-the-moon.mp3",
  "this-is-a-diamond-a-square-standing-on-its-point": "common/this-is-a-diamond-a-square-standing-on-its-point.mp3",
  "this-is-a-heart-draw-two-bumps-and-a-point": "common/this-is-a-heart-draw-two-bumps-and-a-point.mp3",
  "this-is-a-hexagon-draw-6-straight-sides": "common/this-is-a-hexagon-draw-6-straight-sides.mp3",
  "this-is-a-parallelogram-a-rectangle-that-leans-over": "common/this-is-a-parallelogram-a-rectangle-that-leans-over.mp3",
  "this-is-a-pentagon-draw-5-straight-sides": "common/this-is-a-pentagon-draw-5-straight-sides.mp3",
  "this-is-a-rectangle-2-long-sides-and-2-short-sides": "common/this-is-a-rectangle-2-long-sides-and-2-short-sides.mp3",
  "this-is-a-square-draw-4-sides-that-are-all-the-same": "common/this-is-a-square-draw-4-sides-that-are-all-the-same.mp3",
  "this-is-a-star-draw-5-pointy-points": "common/this-is-a-star-draw-5-pointy-points.mp3",
  "this-is-a-trapezium-narrow-on-top-wide-at-the-bottom": "common/this-is-a-trapezium-narrow-on-top-wide-at-the-bottom.mp3",
  "this-is-a-triangle-draw-3-straight-sides": "common/this-is-a-triangle-draw-3-straight-sides.mp3",
  "this-is-an-octagon-draw-8-straight-sides": "common/this-is-an-octagon-draw-8-straight-sides.mp3",
  "this-is-an-oval-like-a-circle-but-stretched": "common/this-is-an-oval-like-a-circle-but-stretched.mp3",
  "trace-the-black-borders": "common/trace-the-black-borders.mp3",
  "write-the-words-ordem-e-progresso-order-and-progress": "common/write-the-words-ordem-e-progresso-order-and-progress.mp3",
  "yay-all-done": "common/yay-all-done.mp3",
  "yay-all-done-press-for-a-surprise": "common/yay-all-done-press-for-a-surprise.mp3"
};

// Per-drawing step clips: drawing id → (slug → repo path).
const BY_DRAWING: Record<string, Record<string, string>> = {
  "bear": {
    "add-a-soft-snout": "bear/add-a-soft-snout.mp3",
    "add-two-round-ears-on-top": "bear/add-two-round-ears-on-top.mp3",
    "now-color-the-bear-in": "bear/now-color-the-bear-in.mp3"
  },
  "bunny": {
    "add-two-tall-ears": "bunny/add-two-tall-ears.mp3",
    "now-color-the-bunny-in": "bunny/now-color-the-bunny-in.mp3"
  },
  "butterfly": {
    "add-pretty-spots": "butterfly/add-pretty-spots.mp3",
    "draw-the-body-and-antennae": "butterfly/draw-the-body-and-antennae.mp3"
  },
  "butterfly-10": {
    "add-swirly-patterns-on-the-wings": "butterfly-10/add-swirly-patterns-on-the-wings.mp3",
    "finish-with-a-row-of-flowers-below": "butterfly-10/finish-with-a-row-of-flowers-below.mp3",
    "last-of-all-write-the-name-b-u-t-t-e-r-f-l-y": "butterfly-10/last-of-all-write-the-name-b-u-t-t-e-r-f-l-y.mp3"
  },
  "butterfly-7": {
    "finish-with-swirly-wing-patterns": "butterfly-7/finish-with-swirly-wing-patterns.mp3"
  },
  "car": {
    "add-big-round-wheels": "car/add-big-round-wheels.mp3"
  },
  "car-10": {
    "add-a-side-mirror-and-a-puff-of-exhaust": "car-10/add-a-side-mirror-and-a-puff-of-exhaust.mp3",
    "add-the-road": "car-10/add-the-road.mp3",
    "finish-with-a-sunny-sky": "car-10/finish-with-a-sunny-sky.mp3",
    "last-of-all-write-the-name-c-a-r": "car-10/last-of-all-write-the-name-c-a-r.mp3"
  },
  "car-7": {
    "finish-with-the-road": "car-7/finish-with-the-road.mp3"
  },
  "cat": {
    "add-a-little-triangle-nose": "cat/add-a-little-triangle-nose.mp3",
    "finish-with-whiskers-and-a-smile": "cat/finish-with-whiskers-and-a-smile.mp3",
    "now-two-sparkly-eyes": "cat/now-two-sparkly-eyes.mp3"
  },
  "cat-10": {
    "add-a-curly-tail": "cat-10/add-a-curly-tail.mp3",
    "add-cosy-stripes-on-its-body": "cat-10/add-cosy-stripes-on-its-body.mp3",
    "add-nose-mouth-and-whiskers": "cat-10/add-nose-mouth-and-whiskers.mp3",
    "finish-with-a-ball-of-yarn-to-play-with": "cat-10/finish-with-a-ball-of-yarn-to-play-with.mp3",
    "last-of-all-write-the-name-c-a-t": "cat-10/last-of-all-write-the-name-c-a-t.mp3"
  },
  "cat-7": {
    "add-the-nose-mouth-and-whiskers": "cat-7/add-the-nose-mouth-and-whiskers.mp3",
    "finish-with-a-curly-tail": "cat-7/finish-with-a-curly-tail.mp3"
  },
  "cloud": {
    "add-even-more-rain": "cloud/add-even-more-rain.mp3",
    "add-some-big-raindrops": "cloud/add-some-big-raindrops.mp3",
    "draw-a-fluffy-cloud": "cloud/draw-a-fluffy-cloud.mp3"
  },
  "cloud-10": {
    "add-a-colourful-umbrella": "cloud-10/add-a-colourful-umbrella.mp3",
    "add-a-splashy-puddle": "cloud-10/add-a-splashy-puddle.mp3",
    "last-of-all-write-the-name-c-l-o-u-d": "cloud-10/last-of-all-write-the-name-c-l-o-u-d.mp3"
  },
  "cloud-7": {
    "finish-with-a-splashy-puddle": "cloud-7/finish-with-a-splashy-puddle.mp3"
  },
  "cow": {
    "add-a-big-muzzle-and-a-smile": "cow/add-a-big-muzzle-and-a-smile.mp3",
    "add-two-ears-on-the-sides": "cow/add-two-ears-on-the-sides.mp3",
    "add-two-little-horns": "cow/add-two-little-horns.mp3",
    "now-color-the-cow-in": "cow/now-color-the-cow-in.mp3"
  },
  "cubist-face": {
    "add-a-crooked-smile": "cubist-face/add-a-crooked-smile.mp3",
    "add-two-eyes-make-them-different": "cubist-face/add-two-eyes-make-them-different.mp3",
    "draw-a-wonky-face-shape": "cubist-face/draw-a-wonky-face-shape.mp3",
    "finish-with-cubist-lines": "cubist-face/finish-with-cubist-lines.mp3"
  },
  "dinosaur": {
    "finish-with-a-friendly-eye": "dinosaur/finish-with-a-friendly-eye.mp3"
  },
  "dinosaur-10": {
    "add-a-little-arm": "dinosaur-10/add-a-little-arm.mp3",
    "add-an-eye-and-spots": "dinosaur-10/add-an-eye-and-spots.mp3",
    "finish-with-the-ground-and-a-fern": "dinosaur-10/finish-with-the-ground-and-a-fern.mp3",
    "last-of-all-write-the-name-d-i-n-o-s-a-u-r": "dinosaur-10/last-of-all-write-the-name-d-i-n-o-s-a-u-r.mp3"
  },
  "dinosaur-7": {
    "finish-with-an-eye-and-spots": "dinosaur-7/finish-with-an-eye-and-spots.mp3"
  },
  "dog": {
    "add-two-floppy-ears": "dog/add-two-floppy-ears.mp3",
    "finish-with-a-happy-smile": "dog/finish-with-a-happy-smile.mp3",
    "give-it-a-cute-nose": "dog/give-it-a-cute-nose.mp3",
    "now-color-him-all-in": "dog/now-color-him-all-in.mp3",
    "now-draw-two-big-eyes": "dog/now-draw-two-big-eyes.mp3",
    "start-with-a-big-round-head": "dog/start-with-a-big-round-head.mp3"
  },
  "dog-10": {
    "add-a-collar-with-a-name-tag": "dog-10/add-a-collar-with-a-name-tag.mp3",
    "add-a-little-tongue": "dog-10/add-a-little-tongue.mp3",
    "add-a-wagging-tail": "dog-10/add-a-wagging-tail.mp3",
    "add-eyes-and-eyebrows": "dog-10/add-eyes-and-eyebrows.mp3",
    "draw-the-nose-and-mouth": "dog-10/draw-the-nose-and-mouth.mp3",
    "finish-with-the-ground-and-a-bone": "dog-10/finish-with-the-ground-and-a-bone.mp3",
    "last-of-all-write-the-dog-s-name-d-o-g": "dog-10/last-of-all-write-the-dog-s-name-d-o-g.mp3"
  },
  "dog-7": {
    "add-the-eyes-and-eyebrows": "dog-7/add-the-eyes-and-eyebrows.mp3",
    "draw-the-nose-and-a-smiley-mouth": "dog-7/draw-the-nose-and-a-smiley-mouth.mp3",
    "finish-with-a-wagging-tail": "dog-7/finish-with-a-wagging-tail.mp3"
  },
  "duck": {
    "add-a-little-feather-tuft-on-top": "duck/add-a-little-feather-tuft-on-top.mp3",
    "add-a-wide-orange-beak": "duck/add-a-wide-orange-beak.mp3",
    "add-two-rosy-cheeks": "duck/add-two-rosy-cheeks.mp3",
    "draw-a-line-on-the-beak": "duck/draw-a-line-on-the-beak.mp3",
    "now-color-the-duck-in": "duck/now-color-the-duck-in.mp3"
  },
  "elephant": {
    "add-a-long-trunk": "elephant/add-a-long-trunk.mp3",
    "add-two-big-floppy-ears": "elephant/add-two-big-floppy-ears.mp3",
    "add-two-little-tusks": "elephant/add-two-little-tusks.mp3",
    "now-color-the-elephant-in": "elephant/now-color-the-elephant-in.mp3"
  },
  "family-10": {
    "add-the-family-pet-dog": "family-10/add-the-family-pet-dog.mp3",
    "draw-a-little-house-behind": "family-10/draw-a-little-house-behind.mp3",
    "finish-with-the-sun": "family-10/finish-with-the-sun.mp3",
    "last-of-all-write-the-name-f-a-m-i-l-y": "family-10/last-of-all-write-the-name-f-a-m-i-l-y.mp3",
    "now-colour-your-family-scene-in": "family-10/now-colour-your-family-scene-in.mp3"
  },
  "family-7": {
    "add-a-bright-sun": "family-7/add-a-bright-sun.mp3"
  },
  "fish": {
    "add-a-fin-on-top-and-bottom": "fish/add-a-fin-on-top-and-bottom.mp3",
    "finish-with-an-eye-and-a-smile": "fish/finish-with-an-eye-and-a-smile.mp3"
  },
  "fish-10": {
    "add-rising-bubbles": "fish-10/add-rising-bubbles.mp3",
    "add-two-rows-of-curvy-scales": "fish-10/add-two-rows-of-curvy-scales.mp3",
    "add-wavy-seaweed": "fish-10/add-wavy-seaweed.mp3",
    "last-of-all-write-the-name-f-i-s-h": "fish-10/last-of-all-write-the-name-f-i-s-h.mp3",
    "now-color-the-fish-in": "fish-10/now-color-the-fish-in.mp3"
  },
  "fish-7": {
    "add-curvy-scales": "fish-7/add-curvy-scales.mp3",
    "finish-with-bubbles": "fish-7/finish-with-bubbles.mp3"
  },
  "flag-algeria": {
    "add-a-line-down-the-middle": "flag-algeria/add-a-line-down-the-middle.mp3",
    "last-of-all-write-the-name-a-l-g-e-r-i-a": "flag-algeria/last-of-all-write-the-name-a-l-g-e-r-i-a.mp3"
  },
  "flag-argentina": {
    "draw-a-smiling-sun-in-the-middle": "flag-argentina/draw-a-smiling-sun-in-the-middle.mp3",
    "last-of-all-write-the-name-a-r-g-e-n-t-i-n-a": "flag-argentina/last-of-all-write-the-name-a-r-g-e-n-t-i-n-a.mp3"
  },
  "flag-australia": {
    "last-of-all-write-the-name-a-u-s-t-r-a-l-i-a": "flag-australia/last-of-all-write-the-name-a-u-s-t-r-a-l-i-a.mp3"
  },
  "flag-austria": {
    "last-of-all-write-the-name-a-u-s-t-r-i-a": "flag-austria/last-of-all-write-the-name-a-u-s-t-r-i-a.mp3"
  },
  "flag-belgium": {
    "last-of-all-write-the-name-b-e-l-g-i-u-m": "flag-belgium/last-of-all-write-the-name-b-e-l-g-i-u-m.mp3"
  },
  "flag-bosnia-and-herzegovina": {
    "add-a-line-of-little-stars": "flag-bosnia-and-herzegovina/add-a-line-of-little-stars.mp3",
    "draw-a-big-yellow-triangle": "flag-bosnia-and-herzegovina/draw-a-big-yellow-triangle.mp3",
    "last-of-all-write-the-name-b-o-s-n-i-a-a-n-d-h-e-r-z-e-g-o-v-i-n-a": "flag-bosnia-and-herzegovina/last-of-all-write-the-name-b-o-s-n-i-a-a-n-d-h-e-r-z-e-g-o-v-i-n-a.mp3"
  },
  "flag-brazil": {
    "add-a-curvy-band": "flag-brazil/add-a-curvy-band.mp3",
    "draw-a-big-diamond": "flag-brazil/draw-a-big-diamond.mp3",
    "draw-a-circle-inside": "flag-brazil/draw-a-circle-inside.mp3",
    "last-of-all-write-the-name-b-r-a-z-i-l": "flag-brazil/last-of-all-write-the-name-b-r-a-z-i-l.mp3"
  },
  "flag-canada": {
    "add-two-lines-down": "flag-canada/add-two-lines-down.mp3",
    "draw-a-maple-leaf-in-the-middle": "flag-canada/draw-a-maple-leaf-in-the-middle.mp3",
    "last-of-all-write-the-name-c-a-n-a-d-a": "flag-canada/last-of-all-write-the-name-c-a-n-a-d-a.mp3"
  },
  "flag-cape-verde": {
    "add-10-little-stars-in-a-circle": "flag-cape-verde/add-10-little-stars-in-a-circle.mp3",
    "add-a-band-across-the-bottom-half": "flag-cape-verde/add-a-band-across-the-bottom-half.mp3",
    "last-of-all-write-the-name-c-a-p-e-v-e-r-d-e": "flag-cape-verde/last-of-all-write-the-name-c-a-p-e-v-e-r-d-e.mp3"
  },
  "flag-china": {
    "add-four-little-stars": "flag-china/add-four-little-stars.mp3",
    "draw-one-big-star": "flag-china/draw-one-big-star.mp3",
    "last-of-all-write-the-name-c-h-i-n-a": "flag-china/last-of-all-write-the-name-c-h-i-n-a.mp3"
  },
  "flag-colombia": {
    "last-of-all-write-the-name-c-o-l-o-m-b-i-a": "flag-colombia/last-of-all-write-the-name-c-o-l-o-m-b-i-a.mp3"
  },
  "flag-croatia": {
    "draw-a-shield-in-the-middle": "flag-croatia/draw-a-shield-in-the-middle.mp3",
    "fill-it-with-a-checkerboard": "flag-croatia/fill-it-with-a-checkerboard.mp3",
    "last-of-all-write-the-name-c-r-o-a-t-i-a": "flag-croatia/last-of-all-write-the-name-c-r-o-a-t-i-a.mp3"
  },
  "flag-curacao": {
    "add-a-wide-stripe-across-the-bottom": "flag-curacao/add-a-wide-stripe-across-the-bottom.mp3",
    "draw-two-white-stars-in-the-corner": "flag-curacao/draw-two-white-stars-in-the-corner.mp3",
    "last-of-all-write-the-name-c-u-r-a-c-a-o": "flag-curacao/last-of-all-write-the-name-c-u-r-a-c-a-o.mp3"
  },
  "flag-czech-republic": {
    "draw-a-triangle-from-the-side": "flag-czech-republic/draw-a-triangle-from-the-side.mp3",
    "last-of-all-write-the-name-c-z-e-c-h-r-e-p-u-b-l-i-c": "flag-czech-republic/last-of-all-write-the-name-c-z-e-c-h-r-e-p-u-b-l-i-c.mp3"
  },
  "flag-denmark": {
    "last-of-all-write-the-name-d-e-n-m-a-r-k": "flag-denmark/last-of-all-write-the-name-d-e-n-m-a-r-k.mp3"
  },
  "flag-dr-congo": {
    "add-a-star-in-the-top-corner": "flag-dr-congo/add-a-star-in-the-top-corner.mp3",
    "add-a-thinner-stripe-inside-it": "flag-dr-congo/add-a-thinner-stripe-inside-it.mp3",
    "draw-a-wide-stripe-corner-to-corner": "flag-dr-congo/draw-a-wide-stripe-corner-to-corner.mp3",
    "last-of-all-write-the-name-d-r-c-o-n-g-o": "flag-dr-congo/last-of-all-write-the-name-d-r-c-o-n-g-o.mp3"
  },
  "flag-ecuador": {
    "draw-a-shield-with-a-bird-on-top": "flag-ecuador/draw-a-shield-with-a-bird-on-top.mp3",
    "last-of-all-write-the-name-e-c-u-a-d-o-r": "flag-ecuador/last-of-all-write-the-name-e-c-u-a-d-o-r.mp3"
  },
  "flag-egypt": {
    "draw-a-little-eagle-in-the-middle": "flag-egypt/draw-a-little-eagle-in-the-middle.mp3",
    "last-of-all-write-the-name-e-g-y-p-t": "flag-egypt/last-of-all-write-the-name-e-g-y-p-t.mp3"
  },
  "flag-england": {
    "draw-a-big-red-cross": "flag-england/draw-a-big-red-cross.mp3",
    "last-of-all-write-the-name-e-n-g-l-a-n-d": "flag-england/last-of-all-write-the-name-e-n-g-l-a-n-d.mp3"
  },
  "flag-finland": {
    "last-of-all-write-the-name-f-i-n-l-a-n-d": "flag-finland/last-of-all-write-the-name-f-i-n-l-a-n-d.mp3"
  },
  "flag-france": {
    "last-of-all-write-the-name-f-r-a-n-c-e": "flag-france/last-of-all-write-the-name-f-r-a-n-c-e.mp3"
  },
  "flag-germany": {
    "last-of-all-write-the-name-g-e-r-m-a-n-y": "flag-germany/last-of-all-write-the-name-g-e-r-m-a-n-y.mp3"
  },
  "flag-ghana": {
    "draw-a-big-star-in-the-middle": "flag-ghana/draw-a-big-star-in-the-middle.mp3",
    "last-of-all-write-the-name-g-h-a-n-a": "flag-ghana/last-of-all-write-the-name-g-h-a-n-a.mp3"
  },
  "flag-greece": {
    "add-a-box-in-the-corner": "flag-greece/add-a-box-in-the-corner.mp3",
    "add-a-cross-in-the-box": "flag-greece/add-a-cross-in-the-box.mp3",
    "last-of-all-write-the-name-g-r-e-e-c-e": "flag-greece/last-of-all-write-the-name-g-r-e-e-c-e.mp3"
  },
  "flag-haiti": {
    "draw-a-little-white-box-in-the-middle": "flag-haiti/draw-a-little-white-box-in-the-middle.mp3",
    "draw-a-palm-tree-on-a-hill": "flag-haiti/draw-a-palm-tree-on-a-hill.mp3",
    "last-of-all-write-the-name-h-a-i-t-i": "flag-haiti/last-of-all-write-the-name-h-a-i-t-i.mp3"
  },
  "flag-india": {
    "draw-a-wheel-in-the-middle": "flag-india/draw-a-wheel-in-the-middle.mp3",
    "last-of-all-write-the-name-i-n-d-i-a": "flag-india/last-of-all-write-the-name-i-n-d-i-a.mp3"
  },
  "flag-iran": {
    "draw-a-little-red-emblem-in-the-middle": "flag-iran/draw-a-little-red-emblem-in-the-middle.mp3",
    "last-of-all-write-the-name-i-r-a-n": "flag-iran/last-of-all-write-the-name-i-r-a-n.mp3"
  },
  "flag-iraq": {
    "last-of-all-write-the-name-i-r-a-q": "flag-iraq/last-of-all-write-the-name-i-r-a-q.mp3",
    "write-three-little-green-marks": "flag-iraq/write-three-little-green-marks.mp3"
  },
  "flag-ireland": {
    "last-of-all-write-the-name-i-r-e-l-a-n-d": "flag-ireland/last-of-all-write-the-name-i-r-e-l-a-n-d.mp3"
  },
  "flag-italy": {
    "last-of-all-write-the-name-i-t-a-l-y": "flag-italy/last-of-all-write-the-name-i-t-a-l-y.mp3"
  },
  "flag-ivory-coast": {
    "last-of-all-write-the-name-i-v-o-r-y-c-o-a-s-t": "flag-ivory-coast/last-of-all-write-the-name-i-v-o-r-y-c-o-a-s-t.mp3"
  },
  "flag-japan": {
    "last-of-all-write-the-name-j-a-p-a-n": "flag-japan/last-of-all-write-the-name-j-a-p-a-n.mp3"
  },
  "flag-jordan": {
    "add-a-star-with-seven-points": "flag-jordan/add-a-star-with-seven-points.mp3",
    "draw-a-triangle-on-the-left": "flag-jordan/draw-a-triangle-on-the-left.mp3",
    "last-of-all-write-the-name-j-o-r-d-a-n": "flag-jordan/last-of-all-write-the-name-j-o-r-d-a-n.mp3"
  },
  "flag-mexico": {
    "add-an-eagle-on-top": "flag-mexico/add-an-eagle-on-top.mp3",
    "draw-a-little-cactus-in-the-middle": "flag-mexico/draw-a-little-cactus-in-the-middle.mp3",
    "last-of-all-write-the-name-m-e-x-i-c-o": "flag-mexico/last-of-all-write-the-name-m-e-x-i-c-o.mp3"
  },
  "flag-morocco": {
    "draw-a-green-five-point-star": "flag-morocco/draw-a-green-five-point-star.mp3",
    "last-of-all-write-the-name-m-o-r-o-c-c-o": "flag-morocco/last-of-all-write-the-name-m-o-r-o-c-c-o.mp3"
  },
  "flag-netherlands": {
    "last-of-all-write-the-name-n-e-t-h-e-r-l-a-n-d-s": "flag-netherlands/last-of-all-write-the-name-n-e-t-h-e-r-l-a-n-d-s.mp3"
  },
  "flag-new-zealand": {
    "last-of-all-write-the-name-n-e-w-z-e-a-l-a-n-d": "flag-new-zealand/last-of-all-write-the-name-n-e-w-z-e-a-l-a-n-d.mp3"
  },
  "flag-norway": {
    "add-a-thinner-cross-inside": "flag-norway/add-a-thinner-cross-inside.mp3",
    "last-of-all-write-the-name-n-o-r-w-a-y": "flag-norway/last-of-all-write-the-name-n-o-r-w-a-y.mp3"
  },
  "flag-panama": {
    "draw-two-stars": "flag-panama/draw-two-stars.mp3",
    "last-of-all-write-the-name-p-a-n-a-m-a": "flag-panama/last-of-all-write-the-name-p-a-n-a-m-a.mp3",
    "split-it-into-four-boxes": "flag-panama/split-it-into-four-boxes.mp3"
  },
  "flag-paraguay": {
    "draw-a-star-inside-a-ring": "flag-paraguay/draw-a-star-inside-a-ring.mp3",
    "last-of-all-write-the-name-p-a-r-a-g-u-a-y": "flag-paraguay/last-of-all-write-the-name-p-a-r-a-g-u-a-y.mp3"
  },
  "flag-portugal": {
    "add-a-line-down": "flag-portugal/add-a-line-down.mp3",
    "draw-a-round-badge-in-the-middle": "flag-portugal/draw-a-round-badge-in-the-middle.mp3",
    "last-of-all-write-the-name-p-o-r-t-u-g-a-l": "flag-portugal/last-of-all-write-the-name-p-o-r-t-u-g-a-l.mp3"
  },
  "flag-qatar": {
    "add-a-zig-zag-line-down": "flag-qatar/add-a-zig-zag-line-down.mp3",
    "last-of-all-write-the-name-q-a-t-a-r": "flag-qatar/last-of-all-write-the-name-q-a-t-a-r.mp3"
  },
  "flag-saudi-arabia": {
    "draw-a-long-sword-underneath": "flag-saudi-arabia/draw-a-long-sword-underneath.mp3",
    "last-of-all-write-the-name-s-a-u-d-i-a-r-a-b-i-a": "flag-saudi-arabia/last-of-all-write-the-name-s-a-u-d-i-a-r-a-b-i-a.mp3",
    "write-some-white-marks-across": "flag-saudi-arabia/write-some-white-marks-across.mp3"
  },
  "flag-scotland": {
    "draw-a-big-white-x-corner-to-corner": "flag-scotland/draw-a-big-white-x-corner-to-corner.mp3",
    "last-of-all-write-the-name-s-c-o-t-l-a-n-d": "flag-scotland/last-of-all-write-the-name-s-c-o-t-l-a-n-d.mp3"
  },
  "flag-senegal": {
    "draw-a-five-point-star-in-the-middle": "flag-senegal/draw-a-five-point-star-in-the-middle.mp3",
    "last-of-all-write-the-name-s-e-n-e-g-a-l": "flag-senegal/last-of-all-write-the-name-s-e-n-e-g-a-l.mp3"
  },
  "flag-singapore": {
    "add-five-little-stars": "flag-singapore/add-five-little-stars.mp3",
    "last-of-all-write-the-name-s-i-n-g-a-p-o-r-e": "flag-singapore/last-of-all-write-the-name-s-i-n-g-a-p-o-r-e.mp3"
  },
  "flag-south-africa": {
    "draw-a-sideways-green-y-across-the-flag": "flag-south-africa/draw-a-sideways-green-y-across-the-flag.mp3",
    "draw-a-triangle-at-the-left-edge": "flag-south-africa/draw-a-triangle-at-the-left-edge.mp3",
    "last-of-all-write-the-name-s-o-u-t-h-a-f-r-i-c-a": "flag-south-africa/last-of-all-write-the-name-s-o-u-t-h-a-f-r-i-c-a.mp3"
  },
  "flag-south-korea": {
    "add-little-bars-in-the-corners": "flag-south-korea/add-little-bars-in-the-corners.mp3",
    "draw-a-circle-in-the-middle": "flag-south-korea/draw-a-circle-in-the-middle.mp3",
    "last-of-all-write-the-name-s-o-u-t-h-k-o-r-e-a": "flag-south-korea/last-of-all-write-the-name-s-o-u-t-h-k-o-r-e-a.mp3"
  },
  "flag-spain": {
    "add-two-lines-across": "flag-spain/add-two-lines-across.mp3",
    "draw-a-shield-and-a-crown": "flag-spain/draw-a-shield-and-a-crown.mp3",
    "last-of-all-write-the-name-s-p-a-i-n": "flag-spain/last-of-all-write-the-name-s-p-a-i-n.mp3"
  },
  "flag-sweden": {
    "last-of-all-write-the-name-s-w-e-d-e-n": "flag-sweden/last-of-all-write-the-name-s-w-e-d-e-n.mp3"
  },
  "flag-switzerland": {
    "add-a-fat-white-cross-in-the-middle": "flag-switzerland/add-a-fat-white-cross-in-the-middle.mp3",
    "last-of-all-write-the-name-s-w-i-t-z-e-r-l-a-n-d": "flag-switzerland/last-of-all-write-the-name-s-w-i-t-z-e-r-l-a-n-d.mp3"
  },
  "flag-tunisia": {
    "add-a-five-point-star": "flag-tunisia/add-a-five-point-star.mp3",
    "last-of-all-write-the-name-t-u-n-i-s-i-a": "flag-tunisia/last-of-all-write-the-name-t-u-n-i-s-i-a.mp3"
  },
  "flag-turkey": {
    "last-of-all-write-the-name-t-u-r-k-e-y": "flag-turkey/last-of-all-write-the-name-t-u-r-k-e-y.mp3"
  },
  "flag-united-arab-emirates": {
    "add-3-stripes-across-the-rest": "flag-united-arab-emirates/add-3-stripes-across-the-rest.mp3",
    "add-a-line-down-for-the-red-bar": "flag-united-arab-emirates/add-a-line-down-for-the-red-bar.mp3",
    "last-of-all-write-the-name-u-n-i-t-e-d-a-r-a-b-e-m-i-r-a-t-e-s": "flag-united-arab-emirates/last-of-all-write-the-name-u-n-i-t-e-d-a-r-a-b-e-m-i-r-a-t-e-s.mp3"
  },
  "flag-united-kingdom": {
    "last-of-all-write-the-name-u-n-i-t-e-d-k-i-n-g-d-o-m": "flag-united-kingdom/last-of-all-write-the-name-u-n-i-t-e-d-k-i-n-g-d-o-m.mp3",
    "trace-the-black-border": "flag-united-kingdom/trace-the-black-border.mp3"
  },
  "flag-united-states": {
    "add-13-stripes-across": "flag-united-states/add-13-stripes-across.mp3",
    "add-50-little-stars": "flag-united-states/add-50-little-stars.mp3",
    "add-a-box-in-the-corner-for-the-stars": "flag-united-states/add-a-box-in-the-corner-for-the-stars.mp3",
    "last-of-all-write-the-name-u-n-i-t-e-d-s-t-a-t-e-s": "flag-united-states/last-of-all-write-the-name-u-n-i-t-e-d-s-t-a-t-e-s.mp3"
  },
  "flag-uruguay": {
    "add-a-box-in-the-corner-for-the-sun": "flag-uruguay/add-a-box-in-the-corner-for-the-sun.mp3",
    "draw-a-smiling-sun-in-the-box": "flag-uruguay/draw-a-smiling-sun-in-the-box.mp3",
    "last-of-all-write-the-name-u-r-u-g-u-a-y": "flag-uruguay/last-of-all-write-the-name-u-r-u-g-u-a-y.mp3"
  },
  "flag-uzbekistan": {
    "add-a-little-cluster-of-stars": "flag-uzbekistan/add-a-little-cluster-of-stars.mp3",
    "add-thin-red-lines-between-the-stripes": "flag-uzbekistan/add-thin-red-lines-between-the-stripes.mp3",
    "last-of-all-write-the-name-u-z-b-e-k-i-s-t-a-n": "flag-uzbekistan/last-of-all-write-the-name-u-z-b-e-k-i-s-t-a-n.mp3"
  },
  "flower": {
    "add-petals-all-around": "flower/add-petals-all-around.mp3",
    "add-the-middle-of-the-flower": "flower/add-the-middle-of-the-flower.mp3",
    "draw-the-stem-and-a-leaf": "flower/draw-the-stem-and-a-leaf.mp3"
  },
  "flower-10": {
    "add-a-buzzy-bee": "flower-10/add-a-buzzy-bee.mp3",
    "add-seeds-and-grass": "flower-10/add-seeds-and-grass.mp3",
    "finish-with-a-shining-sun": "flower-10/finish-with-a-shining-sun.mp3",
    "last-of-all-write-the-name-f-l-o-w-e-r": "flower-10/last-of-all-write-the-name-f-l-o-w-e-r.mp3"
  },
  "flower-7": {
    "add-little-seeds-in-the-middle": "flower-7/add-little-seeds-in-the-middle.mp3"
  },
  "fox": {
    "add-a-white-snout-in-the-middle": "fox/add-a-white-snout-in-the-middle.mp3",
    "now-color-the-fox-in": "fox/now-color-the-fox-in.mp3"
  },
  "frog": {
    "add-a-big-friendly-smile": "frog/add-a-big-friendly-smile.mp3",
    "add-the-white-parts-of-the-eyes": "frog/add-the-white-parts-of-the-eyes.mp3",
    "add-two-big-eye-bumps-on-top": "frog/add-two-big-eye-bumps-on-top.mp3",
    "add-two-big-round-eyes": "frog/add-two-big-round-eyes.mp3",
    "add-two-tiny-nostrils": "frog/add-two-tiny-nostrils.mp3",
    "draw-a-wide-round-head": "frog/draw-a-wide-round-head.mp3",
    "now-color-the-frog-in": "frog/now-color-the-frog-in.mp3"
  },
  "great-wave": {
    "add-foamy-claws-on-top": "great-wave/add-foamy-claws-on-top.mp3",
    "add-little-mount-fuji-behind": "great-wave/add-little-mount-fuji-behind.mp3",
    "draw-the-big-curling-wave": "great-wave/draw-the-big-curling-wave.mp3",
    "finish-with-little-boats-riding-the-sea": "great-wave/finish-with-little-boats-riding-the-sea.mp3"
  },
  "hamster": {
    "add-two-puffy-cheeks": "hamster/add-two-puffy-cheeks.mp3",
    "now-color-the-hamster-in": "hamster/now-color-the-hamster-in.mp3"
  },
  "heart-10": {
    "finish-with-little-hearts-floating-up": "heart-10/finish-with-little-hearts-floating-up.mp3",
    "last-of-all-write-the-name-h-e-a-r-t": "heart-10/last-of-all-write-the-name-h-e-a-r-t.mp3",
    "shoot-an-arrow-through-it": "heart-10/shoot-an-arrow-through-it.mp3"
  },
  "heart-7": {
    "finish-with-two-little-hearts": "heart-7/finish-with-two-little-hearts.mp3"
  },
  "hedgehog": {
    "add-spikes-on-its-back": "hedgehog/add-spikes-on-its-back.mp3",
    "give-it-an-eye-and-a-nose": "hedgehog/give-it-an-eye-and-a-nose.mp3"
  },
  "hedgehog-10": {
    "add-a-third-row-of-tiny-spikes": "hedgehog-10/add-a-third-row-of-tiny-spikes.mp3",
    "add-an-apple-on-its-back": "hedgehog-10/add-an-apple-on-its-back.mp3",
    "finish-with-a-flower-and-grass": "hedgehog-10/finish-with-a-flower-and-grass.mp3",
    "last-of-all-write-the-name-h-e-d-g-e-h-o-g": "hedgehog-10/last-of-all-write-the-name-h-e-d-g-e-h-o-g.mp3"
  },
  "hedgehog-7": {
    "finish-with-an-apple-on-its-back": "hedgehog-7/finish-with-an-apple-on-its-back.mp3"
  },
  "heromask": {
    "add-the-body": "heromask/add-the-body.mp3",
    "add-the-eye-mask-and-eyes": "heromask/add-the-eye-mask-and-eyes.mp3",
    "finish-with-a-lightning-emblem-on-the-chest": "heromask/finish-with-a-lightning-emblem-on-the-chest.mp3"
  },
  "heromask-10": {
    "add-a-big-flowing-cape": "heromask-10/add-a-big-flowing-cape.mp3",
    "add-a-big-zig-zag-lightning-bolt": "heromask-10/add-a-big-zig-zag-lightning-bolt.mp3",
    "add-a-hero-belt": "heromask-10/add-a-hero-belt.mp3",
    "brew-a-storm-cloud-on-the-right": "heromask-10/brew-a-storm-cloud-on-the-right.mp3",
    "last-of-all-write-the-name-s-u-p-e-r-s-t-o-r-m-y": "heromask-10/last-of-all-write-the-name-s-u-p-e-r-s-t-o-r-m-y.mp3"
  },
  "horse": {
    "add-a-smiley-mouth-and-a-forelock": "horse/add-a-smiley-mouth-and-a-forelock.mp3",
    "add-one-big-eye-and-a-nostril": "horse/add-one-big-eye-and-a-nostril.mp3",
    "add-two-pointy-ears-on-top": "horse/add-two-pointy-ears-on-top.mp3",
    "draw-a-long-horse-head-and-neck-from-the-side": "horse/draw-a-long-horse-head-and-neck-from-the-side.mp3",
    "draw-the-flowing-mane-down-the-neck": "horse/draw-the-flowing-mane-down-the-neck.mp3",
    "now-color-the-horse-in": "horse/now-color-the-horse-in.mp3"
  },
  "horse-10": {
    "add-the-hooves-and-a-swishy-tail": "horse-10/add-the-hooves-and-a-swishy-tail.mp3",
    "give-the-pony-a-saddle": "horse-10/give-the-pony-a-saddle.mp3",
    "last-of-all-write-the-name-h-o-r-s-e": "horse-10/last-of-all-write-the-name-h-o-r-s-e.mp3",
    "make-a-sunny-meadow-with-grass": "horse-10/make-a-sunny-meadow-with-grass.mp3",
    "start-with-the-pony-s-body": "horse-10/start-with-the-pony-s-body.mp3"
  },
  "horse-7": {
    "finish-with-little-hooves-and-a-swishy-tail": "horse-7/finish-with-little-hooves-and-a-swishy-tail.mp3",
    "start-with-a-big-rounded-body": "horse-7/start-with-a-big-rounded-body.mp3"
  },
  "house": {
    "add-a-triangle-roof": "house/add-a-triangle-roof.mp3",
    "add-two-windows": "house/add-two-windows.mp3",
    "draw-the-door": "house/draw-the-door.mp3"
  },
  "house-10": {
    "add-a-little-fence-and-flowers": "house-10/add-a-little-fence-and-flowers.mp3",
    "finish-with-a-bright-sun": "house-10/finish-with-a-bright-sun.mp3",
    "last-of-all-write-the-name-h-o-u-s-e": "house-10/last-of-all-write-the-name-h-o-u-s-e.mp3",
    "plant-a-tree-beside-the-house": "house-10/plant-a-tree-beside-the-house.mp3"
  },
  "house-7": {
    "finish-with-a-sun-and-a-path": "house-7/finish-with-a-sun-and-a-path.mp3"
  },
  "jersey": {
    "add-the-collar-at-the-neck": "jersey/add-the-collar-at-the-neck.mp3",
    "add-the-cuffs-and-the-shoulder-seams": "jersey/add-the-cuffs-and-the-shoulder-seams.mp3",
    "add-the-underarm-lines-and-the-side-seams": "jersey/add-the-underarm-lines-and-the-side-seams.mp3",
    "colour-the-red-trim-first": "jersey/colour-the-red-trim-first.mp3",
    "draw-the-hem-then-start-the-big-number": "jersey/draw-the-hem-then-start-the-big-number.mp3",
    "draw-the-shoulders-and-the-sleeves": "jersey/draw-the-shoulders-and-the-sleeves.mp3",
    "draw-the-two-sides-and-the-bottom-of-the-shirt": "jersey/draw-the-two-sides-and-the-bottom-of-the-shirt.mp3",
    "give-the-number-its-3-d-edge": "jersey/give-the-number-its-3-d-edge.mp3",
    "write-the-player-s-name-mbappe": "jersey/write-the-player-s-name-mbappe.mp3"
  },
  "lion": {
    "add-a-cute-nose": "lion/add-a-cute-nose.mp3",
    "add-a-round-face-on-top": "lion/add-a-round-face-on-top.mp3",
    "draw-a-big-fluffy-mane": "lion/draw-a-big-fluffy-mane.mp3",
    "now-color-the-lion-in": "lion/now-color-the-lion-in.mp3"
  },
  "mouse": {
    "add-two-big-round-ears": "mouse/add-two-big-round-ears.mp3",
    "now-color-the-mouse-in": "mouse/now-color-the-mouse-in.mp3"
  },
  "penguin": {
    "add-a-little-orange-beak": "penguin/add-a-little-orange-beak.mp3",
    "add-a-soft-white-tummy": "penguin/add-a-soft-white-tummy.mp3",
    "add-two-little-feet": "penguin/add-two-little-feet.mp3",
    "draw-a-big-round-penguin-body": "penguin/draw-a-big-round-penguin-body.mp3",
    "now-color-the-penguin-in": "penguin/now-color-the-penguin-in.mp3"
  },
  "picasso-portrait": {
    "add-colorful-lips": "picasso-portrait/add-colorful-lips.mp3",
    "add-two-eyes-one-round-one-from-the-side": "picasso-portrait/add-two-eyes-one-round-one-from-the-side.mp3",
    "draw-a-big-head-shape": "picasso-portrait/draw-a-big-head-shape.mp3",
    "draw-a-curvy-line-down-the-middle-that-splits-the-face": "picasso-portrait/draw-a-curvy-line-down-the-middle-that-splits-the-face.mp3",
    "finish-with-wild-hair-and-an-ear": "picasso-portrait/finish-with-wild-hair-and-an-ear.mp3"
  },
  "pig": {
    "add-a-big-snout": "pig/add-a-big-snout.mp3",
    "now-color-the-pig-in": "pig/now-color-the-pig-in.mp3"
  },
  "popstar": {
    "add-a-microphone-to-sing-into": "popstar/add-a-microphone-to-sing-into.mp3",
    "add-the-body-arms-and-legs": "popstar/add-the-body-arms-and-legs.mp3",
    "finish-with-a-sparkly-star": "popstar/finish-with-a-sparkly-star.mp3"
  },
  "popstar-10": {
    "add-a-big-singing-smile": "popstar-10/add-a-big-singing-smile.mp3",
    "add-cool-sunglasses": "popstar-10/add-cool-sunglasses.mp3",
    "add-the-microphone": "popstar-10/add-the-microphone.mp3",
    "finish-with-musical-notes-and-a-star": "popstar-10/finish-with-musical-notes-and-a-star.mp3",
    "last-of-all-write-the-name-p-o-p-s-t-a-r": "popstar-10/last-of-all-write-the-name-p-o-p-s-t-a-r.mp3",
    "put-the-star-on-a-stage-with-a-spotlight": "popstar-10/put-the-star-on-a-stage-with-a-spotlight.mp3"
  },
  "popstar-7": {
    "add-a-microphone-with-a-cord": "popstar-7/add-a-microphone-with-a-cord.mp3",
    "add-a-shiny-star-on-the-shirt": "popstar-7/add-a-shiny-star-on-the-shirt.mp3",
    "finish-with-musical-notes": "popstar-7/finish-with-musical-notes.mp3"
  },
  "princess": {
    "add-a-sparkly-crown": "princess/add-a-sparkly-crown.mp3"
  },
  "princess-10": {
    "add-twinkly-stars": "princess-10/add-twinkly-stars.mp3",
    "draw-her-castle-in-the-distance": "princess-10/draw-her-castle-in-the-distance.mp3",
    "last-of-all-write-the-name-p-r-i-n-c-e-s-s": "princess-10/last-of-all-write-the-name-p-r-i-n-c-e-s-s.mp3"
  },
  "rainbow": {
    "almost-there": "rainbow/almost-there.mp3",
    "another-arc-just-inside": "rainbow/another-arc-just-inside.mp3",
    "another-one": "rainbow/another-one.mp3",
    "draw-the-biggest-arc": "rainbow/draw-the-biggest-arc.mp3",
    "keep-going": "rainbow/keep-going.mp3",
    "the-littlest-arc": "rainbow/the-littlest-arc.mp3"
  },
  "rainbow-10": {
    "add-a-fluffy-cloud-at-each-end": "rainbow-10/add-a-fluffy-cloud-at-each-end.mp3",
    "add-raindrops-falling-from-the-clouds": "rainbow-10/add-raindrops-falling-from-the-clouds.mp3",
    "finish-with-a-sun-and-birds": "rainbow-10/finish-with-a-sun-and-birds.mp3",
    "last-of-all-write-the-name-r-a-i-n-b-o-w": "rainbow-10/last-of-all-write-the-name-r-a-i-n-b-o-w.mp3",
    "now-color-the-whole-sky-in": "rainbow-10/now-color-the-whole-sky-in.mp3"
  },
  "rainbow-7": {
    "add-a-fluffy-cloud-on-the-left": "rainbow-7/add-a-fluffy-cloud-on-the-left.mp3",
    "and-one-on-the-right": "rainbow-7/and-one-on-the-right.mp3"
  },
  "star": {
    "draw-a-twinkly-star": "star/draw-a-twinkly-star.mp3"
  },
  "star-10": {
    "add-a-crescent-moon": "star-10/add-a-crescent-moon.mp3",
    "add-little-stars-in-the-sky": "star-10/add-little-stars-in-the-sky.mp3",
    "add-sparkles-around-it": "star-10/add-sparkles-around-it.mp3",
    "last-of-all-write-the-name-s-t-a-r": "star-10/last-of-all-write-the-name-s-t-a-r.mp3"
  },
  "star-7": {
    "add-sparkles-all-around": "star-7/add-sparkles-all-around.mp3"
  },
  "starry-night": {
    "add-a-glowing-moon-and-twinkly-stars": "starry-night/add-a-glowing-moon-and-twinkly-stars.mp3",
    "add-big-swirls-in-the-sky": "starry-night/add-big-swirls-in-the-sky.mp3",
    "draw-the-rolling-hills-at-the-bottom": "starry-night/draw-the-rolling-hills-at-the-bottom.mp3",
    "finish-with-the-tall-cypress-tree": "starry-night/finish-with-the-tall-cypress-tree.mp3"
  },
  "sun": {
    "add-more-rays-in-the-corners": "sun/add-more-rays-in-the-corners.mp3"
  },
  "sun-10": {
    "add-a-fluffy-cloud": "sun-10/add-a-fluffy-cloud.mp3",
    "finish-with-birds-flying-by": "sun-10/finish-with-birds-flying-by.mp3",
    "last-of-all-write-the-name-s-u-n": "sun-10/last-of-all-write-the-name-s-u-n.mp3"
  },
  "sun-7": {
    "finish-with-a-fluffy-cloud": "sun-7/finish-with-a-fluffy-cloud.mp3"
  },
  "tree": {
    "draw-the-trunk": "tree/draw-the-trunk.mp3"
  },
  "tree-10": {
    "add-a-little-bird": "tree-10/add-a-little-bird.mp3",
    "add-yummy-apples": "tree-10/add-yummy-apples.mp3",
    "hang-a-little-swing-from-a-branch": "tree-10/hang-a-little-swing-from-a-branch.mp3",
    "last-of-all-write-the-name-t-r-e-e": "tree-10/last-of-all-write-the-name-t-r-e-e.mp3"
  },
  "whale": {
    "add-a-big-smile": "whale/add-a-big-smile.mp3",
    "add-a-happy-eye": "whale/add-a-happy-eye.mp3",
    "add-a-splashy-tail": "whale/add-a-splashy-tail.mp3",
    "add-a-water-spout": "whale/add-a-water-spout.mp3",
    "now-color-the-whale-in": "whale/now-color-the-whale-in.mp3"
  }
};

/**
 * Full CDN URL of the clip for this drawing + spoken phrase, or null if there is
 * none (the caller then uses the browser voice). A drawing-specific clip wins
 * over the shared common one.
 */
export function clipUrlFor(drawingId: string | undefined, phrase: string): string | null {
  const slug = clipSlug(phrase);
  const path = (drawingId ? BY_DRAWING[drawingId]?.[slug] : undefined) ?? COMMON[slug];
  return path ? `${AUDIO_BASE}/${path}` : null;
}

export { clipSlug };
